module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBold.e1c83f9.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-SemiBold.ttf
// module id = 4fvE
// module chunks = 1